export const apiName: string = 'tipos-viagens';


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/tipos-viagem/shared/data.service.ts
 **/